<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box">
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<el-tabs class="whole-page-tabs" v-model="activeName" @tab-click="handleClick" tab-position="top">
						<el-tab-pane label="人员绑定记录" name="first" clor="red"></el-tab-pane>
						<el-tab-pane label="车辆绑定记录" name="second"></el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<!-- router-title-box end -->

		<UserBindingTable v-show="activeName == 'first'" ref="userBindingTable" />
		<CarBindingTable v-show="activeName == 'second'" ref="carBindingTable" />

	</div>
</template>

<script>
	import UserBindingTable from '@/components_pages/Record/UserBindingTable'
	import CarBindingTable from '@/components_pages/Record/CarBindingTable'
	import ApiOam from '@/request/api-oam'

	export default {
		/*
		 * 组件名
		 */
		name: "BindingRecord",
		/**
		 * 引用组件
		 * */
		components: {
			// 人员绑定记录组件
			UserBindingTable,
			// 车辆绑定记录组件
			CarBindingTable
		},
		data() {
			return {
				activeName: '',
				userRecordFlag: false,
				carRecordFlag: false
			}
		},
		created() {
			this.searchResource(this.$store.state.infoUri[0], 1)
			this.searchResource(this.$store.state.infoUri[1], 2)
		},
		mounted() {

		},
		methods: {
			/**
			 * @Des 关闭路由
			 * @Auth
			 * @Date
			 */
			closeRouter() {
				// 跳转到 首页
				this.$router.replace({
					path: this.$store.state.homePage
				}, () => {}, () => {});
			}, // closeRouter
			handleClick(tab, event) {
				if(tab.index == 0) {
					//请求1
					this.$refs.userBindingTable.researchRecord();
				} else if(tab.index == 1) {
					//请求2
					this.$refs.carBindingTable.researchRecord();
				}
			},
			searchResource(uri, type) {
				this.$request.postJsonRequest(ApiOam.Search_All_Resources_Uri, {
					resourceType: type,
					showType: this.$store.state.showType, // 20,
					uri: uri
				}).then(result => {
					// console.log(type);
					if(result.total > 0) {
						if(type == 1) {
							this.userRecordFlag = true;
							this.activeName = 'first';
						} else if(type == 2) {
							this.carRecordFlag = true;
							if(this.activeName != 'first') {
								this.activeName = 'second';
							}
						}
					}
				}).catch(error => {
					console.error('查询资源异常', ApiOam.Search_All_Resources_Uri, error);
				})
			},

		},
	}
	// API 资源信息
</script>

/* CSS */
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/system-manager/record/BindingRecord.vue